import { AwsRum, AwsRumConfig } from 'aws-rum-web'

export interface RumConfig {
  applicationId: string
  applicationVersion: string
  region: string
  identityPoolId: string
  telemetries?: string[]
  allowCookies?: boolean
  enableXRay?: boolean
  sessionSampleRate?: number
  endpoint?: string
}

let rumClient: AwsRum | null = null

export const initializeRUM = async (config: RumConfig): Promise<void> => {
  if (rumClient) {
    return
  }

  const rumConfig: AwsRumConfig = {
    sessionSampleRate: config.sessionSampleRate ?? 1,
    identityPoolId: config.identityPoolId,
    endpoint:
      config.endpoint || `https://dataplane.rum.${config.region}.amazonaws.com`,
    telemetries: config.telemetries || ['errors', 'performance', 'http'],
    allowCookies: config.allowCookies ?? true,
    enableXRay: config.enableXRay ?? false,
  }

  try {
    const awsRum = new AwsRum(
      config.applicationId,
      config.applicationVersion,
      config.region,
      rumConfig,
    )
    rumClient = awsRum
  } catch (error) {
    console.error('Failed to initialize AWS RUM:', error)
  }
}

export const recordPageView = (pageId: string): void => {
  if (!rumClient) {
    return
  }
  try {
    rumClient.recordPageView(pageId)
  } catch (error) {
    console.warn('Failed to record page view:', error)
  }
}

export const recordError = (error: Error | string): void => {
  if (!rumClient) {
    return
  }
  try {
    rumClient.recordError(error)
  } catch (rumError) {
    console.warn('Failed to record error to RUM:', rumError)
  }
}

export const recordEvent = (
  eventType: string,
  eventData: Record<string, string | boolean | number>,
): void => {
  if (!rumClient) {
    return
  }
  rumClient.recordEvent(eventType, eventData)
}

export const addSessionAttributes = (
  attributes: Record<string, string | boolean | number>,
): void => {
  if (!rumClient) {
    return
  }
  rumClient.addSessionAttributes(attributes)
}

export const getRumClient = (): AwsRum | null => {
  return rumClient
}
